/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
/* tslint:disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as import0 from '../../../../app/shared/inputs.component/input.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '../../../../app/services/inut.validator.service';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from '@angular/core/src/change_detection/constants';
import * as import9 from '@angular/core/src/linker/component_factory';
import * as import10 from '@angular/material/input/input-container';
import * as import11 from '../../../node_modules/@angular/material/input/input-container.ngfactory';
import * as import12 from '@angular/core/src/linker/query_list';
import * as import13 from '@angular/core/src/linker/element_ref';
import * as import14 from '@angular/forms/src/directives/ng_control';
var Wrapper_InputComponent = (function () {
    function Wrapper_InputComponent(p0) {
        this._changed = false;
        this.context = new import0.InputComponent(p0);
        this._expr_0 = import1.UNINITIALIZED;
    }
    Wrapper_InputComponent.prototype.ngOnDetach = function (view, componentView, el) {
    };
    Wrapper_InputComponent.prototype.ngOnDestroy = function () {
    };
    Wrapper_InputComponent.prototype.check_input = function (currValue, throwOnChange, forceUpdate) {
        if ((forceUpdate || import3.checkBinding(throwOnChange, this._expr_0, currValue))) {
            this._changed = true;
            this.context.input = currValue;
            this._expr_0 = currValue;
        }
    };
    Wrapper_InputComponent.prototype.ngDoCheck = function (view, el, throwOnChange) {
        var changed = this._changed;
        this._changed = false;
        return changed;
    };
    Wrapper_InputComponent.prototype.checkHost = function (view, componentView, el, throwOnChange) {
    };
    Wrapper_InputComponent.prototype.handleEvent = function (eventName, $event) {
        var result = true;
        return result;
    };
    Wrapper_InputComponent.prototype.subscribe = function (view, _eventHandler) {
        this._eventHandler = _eventHandler;
    };
    return Wrapper_InputComponent;
}());
export { Wrapper_InputComponent };
var renderType_InputComponent_Host = import3.createRenderComponentType('', 0, import5.ViewEncapsulation.None, [], {});
var View_InputComponent_Host0 = (function (_super) {
    __extends(View_InputComponent_Host0, _super);
    function View_InputComponent_Host0(viewUtils, parentView, parentIndex, parentElement) {
        return _super.call(this, View_InputComponent_Host0, renderType_InputComponent_Host, import7.ViewType.HOST, viewUtils, parentView, parentIndex, parentElement, import8.ChangeDetectorStatus.CheckAlways) || this;
    }
    View_InputComponent_Host0.prototype.createInternal = function (rootSelector) {
        this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer, 'app-input', import3.EMPTY_INLINE_ARRAY, rootSelector, null);
        this.compView_0 = new View_InputComponent0(this.viewUtils, this, 0, this._el_0);
        this._InputValidatorService_0_3 = new import6.InputValidatorService();
        this._InputComponent_0_4 = new Wrapper_InputComponent(this._InputValidatorService_0_3);
        this.compView_0.create(this._InputComponent_0_4.context);
        this.init(this._el_0, (this.renderer.directRenderer ? null : [this._el_0]), null);
        return new import9.ComponentRef_(0, this, this._el_0, this._InputComponent_0_4.context);
    };
    View_InputComponent_Host0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import6.InputValidatorService) && (0 === requestNodeIndex))) {
            return this._InputValidatorService_0_3;
        }
        if (((token === import0.InputComponent) && (0 === requestNodeIndex))) {
            return this._InputComponent_0_4.context;
        }
        return notFoundResult;
    };
    View_InputComponent_Host0.prototype.detectChangesInternal = function (throwOnChange) {
        this._InputComponent_0_4.ngDoCheck(this, this._el_0, throwOnChange);
        this.compView_0.internalDetectChanges(throwOnChange);
    };
    View_InputComponent_Host0.prototype.destroyInternal = function () {
        this.compView_0.destroy();
    };
    View_InputComponent_Host0.prototype.visitRootNodesInternal = function (cb, ctx) {
        cb(this._el_0, ctx);
    };
    return View_InputComponent_Host0;
}(import2.AppView));
export var InputComponentNgFactory = new import9.ComponentFactory('app-input', View_InputComponent_Host0, import0.InputComponent);
var styles_InputComponent = ['.my-input[_ngcontent-%COMP%] { margin: 10px 10px}'];
var renderType_InputComponent = import3.createRenderComponentType('', 0, import5.ViewEncapsulation.Emulated, styles_InputComponent, {});
var View_InputComponent0 = (function (_super) {
    __extends(View_InputComponent0, _super);
    function View_InputComponent0(viewUtils, parentView, parentIndex, parentElement) {
        var _this = _super.call(this, View_InputComponent0, renderType_InputComponent, import7.ViewType.COMPONENT, viewUtils, parentView, parentIndex, parentElement, import8.ChangeDetectorStatus.CheckAlways) || this;
        _this._expr_11 = import1.UNINITIALIZED;
        return _this;
    }
    View_InputComponent0.prototype.createInternal = function (rootSelector) {
        var parentRenderNode = this.renderer.createViewRoot(this.parentElement);
        this._el_0 = import3.createRenderElement(this.renderer, parentRenderNode, 'md-input-container', new import3.InlineArray2(2, 'class', 'my-input'), null);
        this.compView_0 = new import11.View_MdInputContainer0(this.viewUtils, this, 0, this._el_0);
        this._MdInputContainer_0_3 = new import11.Wrapper_MdInputContainer();
        this._query_MdInputDirective_0_0 = new import12.QueryList();
        this._query_MdPlaceholder_0_1 = new import12.QueryList();
        this._query_MdHint_0_2 = new import12.QueryList();
        this._text_1 = this.renderer.createText(null, '\n            ', null);
        this._el_2 = import3.createRenderElement(this.renderer, null, 'input', new import3.InlineArray2(2, 'mdInput', ''), null);
        this._MdInputDirective_2_3 = new import11.Wrapper_MdInputDirective(new import13.ElementRef(this._el_2), this.renderer, this.parentView.injectorGet(import14.NgControl, this.parentIndex, null));
        this._text_3 = this.renderer.createText(null, '\n        ', null);
        this.compView_0.create(this._MdInputContainer_0_3.context);
        this._text_4 = this.renderer.createText(parentRenderNode, '\n                ', null);
        var disposable_0 = import3.subscribeToRenderElement(this, this._el_0, new import3.InlineArray2(2, 'click', null), this.eventHandler(this.handleEvent_0));
        var disposable_1 = import3.subscribeToRenderElement(this, this._el_2, new import3.InlineArray8(6, 'input', null, 'blur', null, 'focus', null), this.eventHandler(this.handleEvent_2));
        this._query_MdInputDirective_0_0.reset([this._MdInputDirective_2_3.context]);
        this._MdInputContainer_0_3.context._mdInputChild = this._query_MdInputDirective_0_0.first;
        this._query_MdPlaceholder_0_1.reset([]);
        this._MdInputContainer_0_3.context._placeholderChild = this._query_MdPlaceholder_0_1.first;
        this.init(null, (this.renderer.directRenderer ? null : [
            this._el_0,
            this._text_1,
            this._el_2,
            this._text_3,
            this._text_4
        ]), [
            disposable_0,
            disposable_1
        ]);
        return null;
    };
    View_InputComponent0.prototype.injectorGetInternal = function (token, requestNodeIndex, notFoundResult) {
        if (((token === import10.MdInputDirective) && (2 === requestNodeIndex))) {
            return this._MdInputDirective_2_3.context;
        }
        if (((token === import10.MdInputContainer) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 3)))) {
            return this._MdInputContainer_0_3.context;
        }
        return notFoundResult;
    };
    View_InputComponent0.prototype.detectChangesInternal = function (throwOnChange) {
        var currVal_0_0_0 = this.context.input.dvdrColor;
        this._MdInputContainer_0_3.check_dividerColor(currVal_0_0_0, throwOnChange, false);
        this._MdInputContainer_0_3.ngDoCheck(this, this._el_0, throwOnChange);
        var currVal_2_0_0 = this.context.input.hint;
        this._MdInputDirective_2_3.check_placeholder(currVal_2_0_0, throwOnChange, false);
        this._MdInputDirective_2_3.ngDoCheck(this, this._el_2, throwOnChange);
        if (!throwOnChange) {
            if (this._query_MdHint_0_2.dirty) {
                this._query_MdHint_0_2.reset([]);
                this._MdInputContainer_0_3.context._hintChildren = this._query_MdHint_0_2;
                this._query_MdHint_0_2.notifyOnChanges();
            }
            if ((this.numberOfChecks === 0)) {
                this._MdInputContainer_0_3.context.ngAfterContentInit();
            }
        }
        this._MdInputContainer_0_3.checkHost(this, this.compView_0, this._el_0, throwOnChange);
        var currVal_11 = this.context.input.preDefData;
        if (import3.checkBinding(throwOnChange, this._expr_11, currVal_11)) {
            this.renderer.setElementProperty(this._el_2, 'value', currVal_11);
            this._expr_11 = currVal_11;
        }
        this._MdInputDirective_2_3.checkHost(this, this, this._el_2, throwOnChange);
        this.compView_0.internalDetectChanges(throwOnChange);
    };
    View_InputComponent0.prototype.destroyInternal = function () {
        this.compView_0.destroy();
        this._MdInputDirective_2_3.ngOnDestroy();
    };
    View_InputComponent0.prototype.visitProjectableNodesInternal = function (nodeIndex, ngContentIndex, cb, ctx) {
        if (((nodeIndex == 0) && (ngContentIndex == 0))) { }
        if (((nodeIndex == 0) && (ngContentIndex == 1))) {
            cb(this._text_1, ctx);
            cb(this._el_2, ctx);
            cb(this._text_3, ctx);
        }
        if (((nodeIndex == 0) && (ngContentIndex == 2))) { }
        if (((nodeIndex == 0) && (ngContentIndex == 3))) { }
        if (((nodeIndex == 0) && (ngContentIndex == 4))) { }
    };
    View_InputComponent0.prototype.handleEvent_0 = function (eventName, $event) {
        this.compView_0.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._MdInputContainer_0_3.handleEvent(eventName, $event) && result);
        return result;
    };
    View_InputComponent0.prototype.handleEvent_2 = function (eventName, $event) {
        this.markPathToRootAsCheckOnce();
        var result = true;
        result = (this._MdInputDirective_2_3.handleEvent(eventName, $event) && result);
        if ((eventName == 'input')) {
            var pd_sub_0 = ((this._el_2.value = this.context.validation.inputControl(this._el_2.value, this.context.input.interval)) !== false);
            result = (pd_sub_0 && result);
        }
        return result;
    };
    return View_InputComponent0;
}(import2.AppView));
export { View_InputComponent0 };
//# sourceMappingURL=input.component.ngfactory.js.map